/* eslint-disable unused-imports/no-unused-vars-ts */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { appConfig, clientConfig } from "../constant/app.constant";
import { SpinnerService } from "./spinner.service";
import { WeightUnitOfMeasure } from "../models/weightUnitOfMeasure";

export const ShippingType = {
  Collection: "collection",
  DropOffStore: "dropOffStore",
  DropOffServiceCenter: "dropOffServiceCenter",
};

@Injectable({ providedIn: "root" })
export class DeliveryOptionsService {
  private _url = `${appConfig.BASE_URL}deliveryoptions`;

  private availableShippingOptions: any[];
  private availableShippingOptionsCollection: any[];
  private availableShippingOptionsDropOffStore: any[];
  private availableShippingOptionsDropOffServiceCenter: any[];
  private shippingOption = clientConfig.SHIPPING_OPTIONS;

  constructor(private httpClient: HttpClient, private spinnerService: SpinnerService) {
    this.loadAvailableShippingOptions();
  }

  getCollectionPoints(address: any, network: any) {
    const merchantId = clientConfig.MERCHANT_ID;
    this.spinnerService.show();

    const result = this.httpClient
      .post(`${this._url}/getcollectionpoints`, { merchantId: merchantId, address: address, network: network })
      .pipe(
        tap(
          (response) => this.spinnerService.hide(),
          (error: any) => this.spinnerService.hide()
        )
      );
    return result;
  }

  getAvailableShippingOptions() {
    this.verifyAvailableShippingOptions();

    return this.availableShippingOptions;
  }
  getAvailableShippingOptionCollection() {
    this.verifyAvailableShippingOptions();

    return this.availableShippingOptionsCollection;
  }
  getAvailableModeOfTransport() {
    return this.getAvailableShippingOptions().map((x) => x.modeOfTransport);
  }
  getShippingOption(modeOfTransport) {
    return this.getAvailableShippingOptions().find((x) => x.modeOfTransport === modeOfTransport);
  }
  getTypeByMode(modeOfTransport) {
    if (!!this.availableShippingOptionsCollection.find((x) => x.modeOfTransport === modeOfTransport)) {
      return ShippingType.Collection;
    }
    if (!!this.availableShippingOptionsDropOffStore.find((x) => x.modeOfTransport === modeOfTransport)) {
      return ShippingType.DropOffStore;
    }
    if (!!this.availableShippingOptionsDropOffServiceCenter.find((x) => x.modeOfTransport === modeOfTransport)) {
      return ShippingType.DropOffServiceCenter;
    }
  }
  private verifyAvailableShippingOptions() {
    if (!this.availableShippingOptions) this.loadAvailableShippingOptions();
    if (this.availableShippingOptions.length === 0) this.loadAvailableShippingOptions();
  }

  private loadAvailableShippingOptions() {
    this.availableShippingOptions = [];
    this.availableShippingOptionsCollection = [];
    this.availableShippingOptionsDropOffStore = [];
    this.availableShippingOptionsDropOffServiceCenter = [];

    if (this.exist(this.shippingOption)) {
      if (this.exist(this.shippingOption.collection)) {
        this.shippingOption.collection.forEach((element) => {
          if (!this.exist(element)) return;
          if (!this.exist(element.modeOfTransport)) return;

          this.availableShippingOptionsCollection.push(element);
        });
      }

      if (this.exist(this.shippingOption.dropOffStore)) {
        this.shippingOption.dropOffStore.forEach((element) => {
          if (!this.exist(element)) return;
          if (!this.exist(element.modeOfTransport)) return;

          this.availableShippingOptionsDropOffStore.push(element);
        });
      }

      if (this.exist(this.shippingOption.dropOffServiceCenter)) {
        this.shippingOption.dropOffServiceCenter.forEach((element) => {
          if (!this.exist(element)) return;
          if (!this.exist(element.modeOfTransport)) return;

          this.availableShippingOptionsDropOffServiceCenter.push(element);
        });
      }

      this.availableShippingOptions = this.availableShippingOptionsCollection.concat(
        this.availableShippingOptionsDropOffStore,
        this.availableShippingOptionsDropOffServiceCenter
      );
    }
  }

  private exist(val1) {
    return val1 !== undefined && val1 !== null;
  }

  mapShippingOptionType(type: string): string
  {
    switch (type) {
      case ShippingType.Collection:
        return "PickUp";
      case ShippingType.DropOffStore:
      case ShippingType.DropOffServiceCenter:
        return "DropOff";
      default:
        return "";
    }
  };

  getMappedWeightUnit(unitofWeight: string) {
    const unit = unitofWeight.trim().toLowerCase();
    return WeightUnitOfMeasure[unit]
  }
}
